export const Toolbar = {
  regular: {
    height: 64,
    minHeight: 64
  }
};
